<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        我的预售订单
	    </header>
	    <!-- 我的订单 -->
	    <div class="lmy-my-order" :style="{'padding-top':$route.path=='/myOrder'?'none':'1.2rem'}">
	        <div class="order-list-item" v-for="item in list" @click="routeTodetails(item)">
	            <div class="item-header">
					<p class="left" style="width:17em">{{item.PresaleName}}</p>
	            	<div class="right">
	            		<span  v-if="item.OrderStatus === 0">未支付 </span>
						<span  v-else-if="item.OrderStatus === 1" >处理中</span>
						<span  v-else-if="item.OrderStatus === 2" >已支付</span>
						<span  v-else-if="item.OrderStatus === 4" >已退款</span>
						<span  v-else-if="item.OrderStatus === 5" >已取消</span>
	            	</div>
	            </div>
	            <div class="item-body">
	                <p>使用期限：{{item.UseTimeFrom|dateToYMDline}}至{{item.UseTimeTo |dateToYMDline}}</p>
	                <p class="room-time">份数：{{item.Count}}</p>
					<p>总计：<span class="sym">¥</span><span class="num">{{item.TotalAmount}}.00</span></p>
	            </div>
	            <div class="item-footer">
					<span class="left">{{item.CreateOn|dateLong}}</span>
					<div class="right">
	                	<div class="r-btn" v-if="item.OrderStatus == 0" @click="routeToPay(item,$event)" >去支付</div>
					</div>
	            </div>
	        </div>
	    </div>

	    <infinite-loading @infinite="initData" ref="infiniteLoading">
		    <span slot="no-more">
		        没有更多了...
		    </span>
		    <span slot="no-results"  >
		        您暂时没有任何预售订单！
		    </span>
		</infinite-loading>
		<div class="book-comfirming" v-if="isBookCancel">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>正在取消订单，请稍候</p>
	            </div>
	        </div>
	    </div>
	<Cancel :option="cancelData" @select="cancelData.select"></Cancel>
	</div>
</template>
<script>
	import InfiniteLoading from 'vue-infinite-loading';
	import Cancel from './../../common/cmpnt/cancel.vue';

	export default{
		name:'myOrder',
		components:{
			InfiniteLoading,
			Cancel
		},
		data(){
			return{
				list:[],
				Page:1,
				PageSize:10,
				total:0,
		        isBookCancel:false,
		        cancelData:{
					show:false,
					title:'取消订单',
					content:'确定取消该订单吗？',
					token:'',
					select:(token)=>{
						this.cancelOrder(token);
					}
				}
      		}
		},
		methods:{
   	 		cancel(item,$event){

   	 			$event.stopPropagation();

   	 			this.cancelData.token=item.Token;
   	 			this.cancelData.show=true;
		    },
 			cancelOrder(token){
	 			var that=this;

	 			var param={
	 				'Token':token
	 			}
	 			that.isBookCancel=true;
				that.getRequest({
						url:that.Api.cancelOrder,
						params:param
					}).then(res => {
						that.isBookCancel=false;
				      	that.cancelData.show=false;


					    if(res&&res.IsSuccess){
					    	that.error({title:'提示',content:'订单取消成功'});
							that.changeFilter();
					    }else{
					    	that.error({title:'提示',content:res.Msg||'取消失败'});
					    }
				});
	 		},
			//去支付
			routeToPay(order,$event){
				$event.stopPropagation();
				// localStorage.thisBookingOrderNO=order.OrderNO;
				this.dao.set('thisBookingOrderNO',order.OrderNO);
				this.$router.push({ path: '/presaleWxPay',query:{OrderNO:order.OrderNO}});
	 		},
	 		//查看订单详情
		    routeTodetails(item){

				this.$router.push({ path: '/presaleOrderDetails',query:{OrderNO:item.OrderNO}});
		    },
	        //条件更新后重置参数和结果
 			changeFilter($state) {
	 			this.Page=1;
	 			this.total=0;
				this.list=[];
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    },
			initData($state){
				var that=this;
				if(that.total>0&&(((that.Page-1)*that.PageSize)>that.total)){
					$state.complete();
					return;
				}
 		 		var param={
					Page:that.Page,
					PageSize:that.PageSize,
				}
				that.postRequest({
					url:that.Api.getSaleOrderList,
					params:param
				}).then(res => {
					if (res&&res.IsSuccess&&res.Result.length>0) {
						  that.total=res.Total;
					    that.Page+=1;
              that.list = that.list.concat(res.Result);
              $state.loaded();
				    } else {
				    	$state.complete();
				    }
				});
			}
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/usr/myPresaleOrder/myPresaleOrder.vue